import { Component, OnInit } from '@angular/core';
import { OkAloneService } from 'src/app/ok-alone.service';

import moment from 'moment';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss']
})

export class AlertsComponent implements OnInit {

  alerts : any;
  view : any;
  selected : any;
  filter : any;
  worker_id : any;
  group : any;
  search : any;
  verify : any;
  sort = 'newest';

  show_notes = localStorage.getItem("okalone-show-notes") ? true : false;

  pagination = { page: 1, pageSize: 1, itemCount: 1, totalPages: 1, pageArray: [1], totalCount: 1 };

  constructor(public okService: OkAloneService) { }

  ngOnInit(): void {

    this.pagination.page = 1;
    this.selected = { startDate: moment().subtract(1, 'months'), endDate: moment() }
    this.verify = '';

    this.getAlerts();

  }

  getAlerts(){

    this.updateFilter();

    //console.log('filter', this.filter);

    this.okService.get("alerts",this.filter)
    .subscribe((data) => {

      this.alerts = data.body;
      this.pagination = this.okService.setPagination(data.headers) ?? this.pagination;

    });


  }
  changePage(){
    //console.log('page',this.okService.pagination.page);
    this.getAlerts();
  }

  updateFilter(){

    this.filter = [];

    this.filter['start'] = this.selected.startDate.format("YYYY-MM-DD");
    this.filter['end'] = this.selected.endDate.format("YYYY-MM-DD");

    this.filter['page'] = this.pagination.page;


    if(this.search){
      this.filter['search'] = this.search;
    }

    if(this.worker_id){
      this.filter['worker_id'] = this.worker_id;
    }

    if(this.group){
      this.filter['group'] = this.group;
    }

    if(this.verify){
      this.filter['verify'] = this.verify;
    }

    this.filter['sort'] = this.sort;

    this.filter['expand'] = 'actions,notes,verify';

  }

  clearFilter(){
    this.filter = [];
    this.selected = { startDate: moment().subtract(1, 'months'), endDate: moment() };
    this.worker_id = null;
    this.group = null;
    this.verify = null;
    this.getAlerts();
  }

  toggleNotes(){
    this.show_notes = !this.show_notes;
    if(this.show_notes){
      localStorage.setItem("okalone-show-notes","show")
    }else{
      localStorage.removeItem("okalone-show-notes")
    }
  }

  isString(val:any): boolean { return typeof val === 'string'; }

  exportAlerts(){
    this.updateFilter();
    this.okService.download("alerts/export",this.filter);
  }

}
